import { useEffect, useState } from 'react';
import { apiBlob } from '../../../core/apiClient.js';
import { journeyPath, type JourneyEvidence } from '../../../core/travel';
import { dateTime, num } from '../../../utils/format';
import { useTranslation } from '../../lib/useTranslation';

export default function JourneyEvidenceView({ costId, stopId, evidence, unit }: { costId: string; stopId: string; evidence: JourneyEvidence; unit?: string }) {
  const t = useTranslation(); const [opened, setOpened] = useState(false); const [url, setUrl] = useState(''); const [error, setError] = useState(false); const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!opened) return;
    let alive = true; let objectUrl = ''; const abort = new AbortController(); setUrl(''); setError(false);
    // Derive the private same-origin endpoint; never put a bearer token into an image URL.
    void apiBlob(journeyPath(costId, `stops/${encodeURIComponent(stopId)}/evidence/${encodeURIComponent(evidence.id)}`), { signal: abort.signal }).then(blob => {
      if (!alive) return; objectUrl = URL.createObjectURL(blob); setUrl(objectUrl);
    }).catch(() => { if (alive) setError(true); });
    return () => { alive = false; abort.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [opened, costId, stopId, evidence.id, attempt]);
  const label = t(`journey.evidenceRole.${evidence.role}`);
  return <div className="jr-review-evidence">
    <button type="button" aria-expanded={opened} onClick={() => setOpened(value => !value)}>{t(opened ? 'journey.hidePhoto' : 'journey.viewPhoto', { role: label })}</button>
    {opened && <figure>{error ? <p role="status">{t('journey.photoUnavailable')} <button type="button" onClick={() => setAttempt(value => value + 1)}>{t('common.retry')}</button></p> : url ? <img src={url} alt={label} /> : <p role="status">{t('common.loading')}</p>}
      <figcaption>{dateTime(evidence.capturedAt)}{evidence.odometer != null && <> · {t('journey.readingValue', { value: num(evidence.odometer, { decimals: 1 }), unit: unit === 'MI' ? 'mi' : unit === 'KM' ? 'km' : '' })}</>}</figcaption>
    </figure>}
  </div>;
}
